import {
  Button as ButtonPrime,
  ButtonProps as ButtonPrimeProps,
} from "primereact/button";
import styles from "./styles.module.css";

type ButtonProps = {
  secondary?: boolean;
} & ButtonPrimeProps;

export default function Button({
  secondary,
  className,
  ...props
}: ButtonProps) {
  return (
    <ButtonPrime
      {...props}
      className={`${styles.button} ${secondary ? styles.secondary : ""} ${className} cursor-pointer`}
    />
  );
}
